import { Grid } from '@mui/material';

import ChecklistOptionRow from './ChecklistOptionRow';
import {
  CHECKLIST_COLUMN_SX,
  CHECKLIST_DIVIDER_COLUMN_SX,
  CHECKLIST_OFFSET_COLUMN_SX,
  CHECKLIST_OFFSET_DIVIDER_COLUMN_SX,
} from '../styles';

import type { ChecklistColumnProps } from '../types';

export default function ChecklistColumn({
  footer,
  isEditable,
  items,
  offset,
  onChange,
  showDivider,
  useNewUi,
}: ChecklistColumnProps) {
  return (
    <Grid
      item
      md={4}
      xs={12}
      sx={
        showDivider
          ? offset
            ? CHECKLIST_OFFSET_DIVIDER_COLUMN_SX
            : CHECKLIST_DIVIDER_COLUMN_SX
          : offset
            ? CHECKLIST_OFFSET_COLUMN_SX
            : CHECKLIST_COLUMN_SX
      }
    >
      {items.map((item) => (
        <ChecklistOptionRow
          key={item.id}
          item={item}
          isEditable={isEditable}
          useNewUi={useNewUi}
          onChange={onChange}
        />
      ))}
      {footer}
    </Grid>
  );
}
